import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { SettingsComponent } from "./settings/settings.component";
import { ProfileComponent } from "./profile/profile.component";
//import { MasterLayoutComponent } from "../mnt-master/master-layout/master-layout.component";
import { ResetPasswordComponent } from "./reset-password/reset-password.component";
import { StaffComponent } from "./staff/staff.component";
import { ClientsComponent } from './clients/clients.component';
import { PrinterComissionsComponent } from './printer-comissions/printer-comissions.component';
import { DesignerCommissionsComponent } from './designer-commissions/designer-commissions.component';
import { AuthGuard } from "../_guards/auth.guard";
import {Role} from "../_models/role";
import { ManageSubscriptionComponent } from './manage-subscription/manage-subscription.component';
import { UpdateCardComponent } from './update-card/update-card.component';


const routes: Routes = [
  {
    path: "settings",
    component: SettingsComponent,
    canActivate: [AuthGuard],
    data: { roles:[Role.Shop] }    
  },
  {
    path: "profile",
    component: ProfileComponent,  
    canActivate: [AuthGuard]
   
  },  
  {
    path: "reset-password",
    component: ResetPasswordComponent,
    canActivate: [AuthGuard]    
  },
  {
    path: "manage-subscription",
    component: ManageSubscriptionComponent,
    canActivate: [AuthGuard]
       
  },
  {
    path: "update-card",
    component: UpdateCardComponent,
    canActivate: [AuthGuard]
       
  },
  {
    path: "listing",
    component: ClientsComponent,
    canActivate: [AuthGuard],
    data: { roles:[Role.Shop] }    
  },
  {
    path: "listing/:clientID",
    component: ClientsComponent,
    canActivate: [AuthGuard],
    data: { roles:[Role.Shop] }    
  },
  {
    path: "printer-commissions",
    component: PrinterComissionsComponent,
    canActivate: [AuthGuard],
    data: { roles:[Role.Shop,Role.Printer] }   
  },
  {
    path: "designer-commissions",
    component: DesignerCommissionsComponent,
    canActivate: [AuthGuard],
    data: { roles:[Role.Shop,Role.Designer] }    
  },
 
  {
    path: ":staff_role",
    component: StaffComponent,
    canActivate: [AuthGuard],
    data: { roles:[Role.Shop] }
    
  } 
  
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MntUsersRoutingModule {}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-users/mnt-users-routing.module.ts